/**
 *
 * @param {HTMLElement} element
 */
export default function addTextColour (element) {
    const el = document.querySelector(element);
    const textColour = el.dataset.textColour;

    // https://stackoverflow.com/questions/1636350/how-to-identify-a-given-string-is-hex-color-format
    const hexCodeExpression = new RegExp("^#(?:[0-9a-fA-F]{3,4}){1,2}$");
    const isHexCode = hexCodeExpression.test(textColour);

    if(isHexCode && el && textColour) {
        el.style.color = `${textColour}`;
    }
}
